export const loginErrors = {
  WRONG_CREDENTIAL:
    "The email address and password that you entered didn't match any account.  Please try again!",
  WRONG_EMAIL: 'Please enter a valid email.',
  WRONG_PASSWORD: 'Please enter a valid password.',
};
